import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-get-ideas',
  template: `
    <app-navigation-menu-list
      [list]="getIdeasList"
      [marginBottomTablet]="'xxsmall'"
    >
    </app-navigation-menu-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionGetIdeasComponent {
  getIdeasList = [
    {
      linkDescription: $localize`Get Web Design Ideas`,
      linkUrl: '/discover/website-design',
    },
    {
      linkDescription: $localize`Get Mobile App Ideas`,
      linkUrl: '/discover/mobile-app-development',
    },
    {
      linkDescription: $localize`Get Graphic Design Ideas`,
      linkUrl: '/discover/graphic-design',
    },
    {
      linkDescription: $localize`Get Logo Design Ideas`,
      linkUrl: '/discover/logo-design',
    },
    {
      linkDescription: $localize`Get 3D Modelling Ideas`,
      linkUrl: '/discover/3d-modeling',
    },
    {
      linkDescription: $localize`Get Illustration Ideas`,
      linkUrl: '/discover',
    },
    {
      linkDescription: $localize`Get Branding Ideas`,
      linkUrl: '/discover/branding',
    },
    {
      linkDescription: $localize`Get Product Design Ideas`,
      linkUrl: '/discover/product-design',
    },
    {
      linkDescription: $localize`Get Package Design Ideas`,
      linkUrl: '/discover/package-design',
    },
    {
      linkDescription: $localize`Get Wordpress Ideas`,
      linkUrl: '/discover/wordpress',
    },
  ];
}
